export const loginConstants = {
  CREATE_REQUEST: "LOGIN_CREATE_REQUEST",
  CREATE_SUCCESS: "LOGIN_CREATE_SUCCESS",
  TIMEOUT_SUCCESS: "LOGIN_TIMEOUT_SUCCESS",
  CREATE_FAILURE: "LOGIN_CREATE_FAILURE",
};
